/**
 * Reorders an item in an array based on drag and drop indices.
 *
 * @param {Object} params - The parameters object.
 * @param {Array} params.list - The original array to be reordered.
 * @param {number} params.dragIndex - The original index of the item being dragged.
 * @param {number} params.hoverIndex - The index of the drop zone where the item is hovered.
 * @returns {Array} - A new array with the item reordered.
 */
export const reorderItem = ({ list, dragIndex, hoverIndex }) => {
  const result = [...list];
  const draggedItem = result[dragIndex];

  // Remove the dragged item from its original position
  result.splice(dragIndex, 1);

  // Calculate the correct insertion index
  // When dragging down (dragIndex < hoverIndex), we need to subtract 1
  // because removing the dragged item shifts all subsequent indices down
  const insertIndex = dragIndex < hoverIndex ? hoverIndex - 1 : hoverIndex;

  // Insert the dragged item at the new position
  result.splice(insertIndex, 0, draggedItem);

  return result;
};
